/** Horizontal scroller used by both the news and media strips. */

interface CarouselIds {
  track: string;
  prev: string;
  next: string;
  slide: string;
}

const GAP_PX = 16;
const EDGE_TOLERANCE_PX = 4;

function initCarousel({ track, prev, next, slide }: CarouselIds): void {
  const trackEl = document.getElementById(track);
  const prevBtn = document.getElementById(prev) as HTMLButtonElement | null;
  const nextBtn = document.getElementById(next) as HTMLButtonElement | null;
  if (!trackEl || !prevBtn || !nextBtn) return;

  const step = (): number => {
    const first = trackEl.querySelector(`.${slide}`);
    return first ? first.getBoundingClientRect().width + GAP_PX : 320;
  };

  prevBtn.addEventListener('click', () => trackEl.scrollBy({ left: -step(), behavior: 'smooth' }));
  nextBtn.addEventListener('click', () => trackEl.scrollBy({ left: step(), behavior: 'smooth' }));

  const sync = (): void => {
    prevBtn.disabled = trackEl.scrollLeft <= EDGE_TOLERANCE_PX;
    nextBtn.disabled =
      trackEl.scrollLeft >= trackEl.scrollWidth - trackEl.clientWidth - EDGE_TOLERANCE_PX;
  };

  trackEl.addEventListener('scroll', sync, { passive: true });
  addEventListener('resize', sync);
  sync();
}

export function initCarousels(): void {
  initCarousel({
    track: 'news-carousel',
    prev: 'news-prev',
    next: 'news-next',
    slide: 'news-slide',
  });
  initCarousel({
    track: 'media-carousel',
    prev: 'media-prev',
    next: 'media-next',
    slide: 'media-slide',
  });
}
